/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description isQueryTruthy
 */

export const isQueryTruthy = (query: string | boolean) => {
  const notFalse = query !== false && query !== 'false'
  return notFalse && (!!query || query === '')
}
